// extracted by mini-css-extract-plugin
export var downArrow = "_jl-0";
export var infoTooltipIcon = "_jl-3";
export var label = "_jl-1";
export var optionCard = "_jl-4";
export var upArrow = "_jl-2";